import { styled as t } from "styled-components";
import { Colors as o } from "../../../styles/colors/index.js";
import { CommentAvatar as r } from "../components/CommentAvatar/index.js";
import { CommentContentRenderer as m } from "../components/CommentContentRenderer/index.js";
import { ParentComment as n } from "../components/ParentComment/index.js";
import { defaultCardSpacing as e, createFocusAnimation as a, Author as i } from "../style.js";
import { Theme as p } from "../../../styles/themes/index.js";
const h = t.div`
  display: flex;
  height: auto;
  width: 100%;
  ${e}

  &[data-focused='true'] {
    animation: ${a(p.colors.Charlie)} 4s linear;
  }
`, v = t(r)`
  margin-right: 4px;
`, u = t(i)`
  margin-right: 8px;
`, P = t(m)`
  color: rgb(${o.Gray});
  * {
    color: rgb(${o.Gray});
  }
`, x = t(n)`
  margin-bottom: 8px;
  opacity: 0.7;
`, y = t.div`
  margin-top: 8px;
`;
export {
  y as BannerContainer,
  u as PrivateCommentAuthor,
  v as PrivateCommentAvatar,
  h as PrivateCommentContainer,
  P as PrivateContent,
  x as PrivateParentComment
};
